import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
  getSelectedAlias,
  setSelectedAlias,
} from '../../store/slices/domainOrchestratorPricingCommittee.slice';

const aliases = ['market-maker', 'inmo'] as const;

export const AliasFilterDropdown = () => {
  const dispatch = useDispatch();
  const selected = useSelector(getSelectedAlias);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectedAlias(e.target.value));
  };

  return (
    <Form.Select
      data-testid="alias-filter"
      style={{ fontSize: '14px' }}
      value={selected}
      onChange={handleChange}
    >
      {aliases.map(alias => (
        <option key={alias} value={alias}>
          {alias}
        </option>
      ))}
    </Form.Select>
  );
};
